import React, { useState } from "react";
import { Link } from "react-router-dom";
import { sendFormPQRS } from "../conexion/vehicles.conexion";

/*eslint-disable */
declare const window: any;

interface propsI {
  handleOpenModal: any;
}

const concesionariosData: any = [
  {
    CONCESIONARIO: "AG OMEGA",
    DEPARTAMENTO: "BOGOTA",
    CIUDAD: "BOGOTÁ",
    "VITRINA (EXPOSICIÓN)": "Carrera 24",
    COD_VITRINA_EXPOSICION: "a17QC00000b84mpYAA",
    NIT: "9014563301",
    "ID Dealers": "302117",
    "ID sucursales": "905590",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "11 BOGOTA",
    City: "BOGOTÁ, D.C.",
  },
  {
    CONCESIONARIO: "AUTAMA",
    DEPARTAMENTO: "QUINDIO",
    CIUDAD: "ARMENIA",
    "VITRINA (EXPOSICIÓN)": "Armenia",
    COD_VITRINA_EXPOSICION: "a17QC00000b83ieYAA",
    NIT: "9009235085",
    "ID Dealers": "302102",
    "ID sucursales": "905558",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "63 QUINDIO",
    City: "ARMENIA",
  },
  {
    CONCESIONARIO: "AUTOLARTE",
    DEPARTAMENTO: "ANTIOQUIA",
    CIUDAD: "RIONEGRO",
    "VITRINA (EXPOSICIÓN)": "Rionegro",
    COD_VITRINA_EXPOSICION: "a17QC00002Gt0CdYAJ",
    NIT: "8909000818",
    "ID Dealers": "302707",
    "ID sucursales": "907056",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "05 ANTIOQUIA",
    City: "RIONEGRO",
  },
  {
    CONCESIONARIO: "AUTOMOTOR",
    DEPARTAMENTO: "BOGOTA",
    CIUDAD: "BOGOTÁ",
    "VITRINA (EXPOSICIÓN)": "Calle 235",
    COD_VITRINA_EXPOSICION: "a17QC00000bL2aXYAS",
    NIT: "9009692000",
    "ID Dealers": "302099",
    "ID sucursales": "905594",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "11 BOGOTA",
    City: "BOGOTÁ, D.C.",
  },
  {
    CONCESIONARIO: "AUTOMOTOR",
    DEPARTAMENTO: "ANTIOQUIA",
    CIUDAD: "MEDELLÍN",
    "VITRINA (EXPOSICIÓN)": "Palacé",
    COD_VITRINA_EXPOSICION: "a17QC00000bL2adYAC",
    NIT: "9009692000",
    "ID Dealers": "302099",
    "ID sucursales": "905600",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "05 ANTIOQUIA",
    City: "MEDELLIN",
  },
  {
    CONCESIONARIO: "MOEVO",
    DEPARTAMENTO: "ANTIOQUIA",
    CIUDAD: "MEDELLÍN",
    "VITRINA (EXPOSICIÓN)": "Itagui",
    COD_VITRINA_EXPOSICION: "a17QC00002GtNebYAF",
    NIT: "8909000818",
    "ID Dealers": "302707",
    "ID sucursales": "907059",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "05 ANTIOQUIA",
    City: "MEDELLIN",
  },
  /* {
    "CONCESIONARIO": "AUTOMOTOR",
    "DEPARTAMENTO": "ANTIOQUIA",
    "CIUDAD": "MEDELLÍN",
    "VITRINA (EXPOSICIÓN)": "Palacé (Taxis)",
    "COD_VITRINA_EXPOSICION": "a17QC00002M3NIgYAN",
    "NIT": "9009692000",
    "ID Dealers": "302099",
    "ID sucursales": "907072",
    "TIPO DE VEHICULOS": "TAXIS",
    "Department_Code_And_Name": "05 ANTIOQUIA",
    "City": "MEDELLIN"
  }, */
  /* {
    CONCESIONARIO: "AUTOMOTOR",
    DEPARTAMENTO: "VALLE DEL CAUCA",
    CIUDAD: "CALI",
    "VITRINA (EXPOSICIÓN)": "Santa Monica",
    COD_VITRINA_EXPOSICION: "a17QC00000bL2aZYAS",
    NIT: "9009692000",
    "ID Dealers": "302099",
    "ID sucursales": "905596",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "76 VALLE DEL CAUCA",
    City: "CALI",
  }, */
  {
    CONCESIONARIO: "AUTONAL",
    DEPARTAMENTO: "BOGOTA",
    CIUDAD: "BOGOTÁ",
    "VITRINA (EXPOSICIÓN)": "La Felicidad Av Boyaca",
    COD_VITRINA_EXPOSICION: "a17QC00001mOwxeYAC",
    NIT: "9017736050",
    "ID Dealers": "302362",
    "ID sucursales": "906434",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "11 BOGOTA",
    City: "BOGOTÁ, D.C.",
  },
  {
    CONCESIONARIO: "AUTONAL",
    DEPARTAMENTO: "META",
    CIUDAD: "VILLAVICENCIO",
    "VITRINA (EXPOSICIÓN)": "Villavicencio",
    COD_VITRINA_EXPOSICION: "a17QC00001mOwxjYAC",
    NIT: "9017736050",
    "ID Dealers": "302362",
    "ID sucursales": "906440",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "50 META",
    City: "VILLAVICENCIO",
  },
  {
    CONCESIONARIO: "AUTONAL",
    DEPARTAMENTO: "BOYACA",
    CIUDAD: "TUNJA",
    "VITRINA (EXPOSICIÓN)": "Tunja",
    COD_VITRINA_EXPOSICION: "a17QC00001mPfInYAK",
    NIT: "9017736050",
    "ID Dealers": "302362",
    "ID sucursales": "906451",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "15 BOYACA",
    City: "TUNJA",
  },
  {
    CONCESIONARIO: "AUTONORTE",
    DEPARTAMENTO: "ATLANTICO",
    CIUDAD: "BARRANQUILLA",
    "VITRINA (EXPOSICIÓN)": "Barranquilla",
    COD_VITRINA_EXPOSICION: "a17QC00000b8409YAA",
    NIT: "8001656941",
    "ID Dealers": "302103",
    "ID sucursales": "905560",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "08 ATLANTICO",
    City: "BARRANQUILLA",
  },
  {
    CONCESIONARIO: "AUTONORTE",
    DEPARTAMENTO: "MAGDALENA",
    CIUDAD: "SANTA MARTA",
    "VITRINA (EXPOSICIÓN)": "Santa Marta",
    COD_VITRINA_EXPOSICION: "a17QC00000b840BYAQ",
    NIT: "8001656941",
    "ID Dealers": "302103",
    "ID sucursales": "905562",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "47 MAGDALENA",
    City: "SANTA MARTA",
  },
  {
    CONCESIONARIO: "AUTONORTE",
    DEPARTAMENTO: "CESAR",
    CIUDAD: "VALLEDUPAR",
    "VITRINA (EXPOSICIÓN)": "Valledupar",
    COD_VITRINA_EXPOSICION: "a17QC00000b840CYAQ",
    NIT: "8001656941",
    "ID Dealers": "302103",
    "ID sucursales": "905563",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "20 CESAR",
    City: "VALLEDUPAR",
  },
  {
    CONCESIONARIO: "AUTONORTE",
    DEPARTAMENTO: "BOLIVAR",
    CIUDAD: "CARTAGENA",
    "VITRINA (EXPOSICIÓN)": "Cartagena",
    COD_VITRINA_EXPOSICION: "a17QC00000b840DYAQ",
    NIT: "8001656941",
    "ID Dealers": "302103",
    "ID sucursales": "905564",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "13 BOLIVAR",
    City: "CARTAGENA",
  },
  {
    CONCESIONARIO: "AUTOPACIFICO",
    DEPARTAMENTO: "VALLE DEL CAUCA",
    CIUDAD: "TULUA",
    "VITRINA (EXPOSICIÓN)": "Tulua",
    COD_VITRINA_EXPOSICION: "a17QC00000r780HYAQ",
    NIT: "8903272824",
    "ID Dealers": "302119",
    "ID sucursales": "906113",
    "TIPO DE VEHICULOS": "PARTICULARES",
    Department_Code_And_Name: "76 VALLE DEL CAUCA",
    City: "TULUA",
  },
  /* {
    "CONCESIONARIO": "AUTOPACIFICO",
    "DEPARTAMENTO": "VALLE DEL CAUCA",
    "CIUDAD": "TULUA",
    "VITRINA_EXPOSICION": "Tulua",
    "COD_VITRINA_EXPOSICION": "a17QC00000r780HYAQ",
    "NIT": "8903272824",
    "ID_Dealers": "302119",
    "ID_sucursales": "906113",
    "TIPO_DE_VEHICULOS": "PARTICULARES",
    "Department_Code_And_Name": "76 VALLE DEL CAUCA",
    "City": "TULUA"
  }, */
  {
    CONCESIONARIO: "AUTOPACIFICO",
    DEPARTAMENTO: "VALLE DEL CAUCA",
    CIUDAD: "PALMIRA",
    VITRINA_EXPOSICION: "Palmira",
    COD_VITRINA_EXPOSICION: "a17QC00000r780IYAQ",
    NIT: "8903272824",
    ID_Dealers: "302119",
    ID_sucursales: "906114",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "76 VALLE DEL CAUCA",
    City: "PALMIRA",
  },
  {
    CONCESIONARIO: "AUTOPACIFICO",
    DEPARTAMENTO: "VALLE DEL CAUCA",
    CIUDAD: "CALI",
    VITRINA_EXPOSICION: "Cali",
    COD_VITRINA_EXPOSICION: "a17QC00000b86d4YAA",
    NIT: "8903272824",
    ID_Dealers: "302119",
    ID_sucursales: "905609",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "76 VALLE DEL CAUCA",
    City: "CALI",
  },
  {
    CONCESIONARIO: "AUTOPACIFICO",
    DEPARTAMENTO: "VALLE DEL CAUCA",
    CIUDAD: "CALI",
    VITRINA_EXPOSICION: "Cali",
    COD_VITRINA_EXPOSICION: "a17QC00003IVdefYAD",
    NIT: "8903272824",
    ID_Dealers: "302119",
    ID_sucursales: "905609",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "76 VALLE DEL CAUCA",
    City: "CALI",
  },
  {
    CONCESIONARIO: "LOS COCHES",
    DEPARTAMENTO: "CALDAS",
    CIUDAD: "MANIZALES",
    VITRINA_EXPOSICION: "Manizales",
    COD_VITRINA_EXPOSICION: "a17QC00002jpk25YAA",
    NIT: "8600526342",
    ID_Dealers: "302104",
    ID_sucursales: "905565",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "17 CALDAS",
    City: "MANIZALES",
  },
  {
    CONCESIONARIO: "LOS COCHES",
    DEPARTAMENTO: "RISARALDA",
    CIUDAD: "PEREIRA",
    VITRINA_EXPOSICION: "Pereira",
    COD_VITRINA_EXPOSICION: "a17QC00002jpk26YAA",
    NIT: "8600526342",
    ID_Dealers: "302104",
    ID_sucursales: "905566",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "66 RISARALDA",
    City: "PEREIRA",
  },
  {
    CONCESIONARIO: "CENTRAL MOTOR",
    DEPARTAMENTO: "SANTANDER",
    CIUDAD: "BUCARAMANGA",
    VITRINA_EXPOSICION: "Bucaramanga",
    COD_VITRINA_EXPOSICION: "a17QC00000b86HmYAI",
    NIT: "8040028327",
    ID_Dealers: "302111",
    ID_sucursales: "905584",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "68 SANTANDER",
    City: "BUCARAMANGA",
  },
  {
    CONCESIONARIO: "DISTRIROBLE",
    DEPARTAMENTO: "CORDOBA",
    CIUDAD: "MONTERÍA",
    VITRINA_EXPOSICION: "Montería",
    COD_VITRINA_EXPOSICION: "a17QC00000b86L6YAI",
    NIT: "8910000178",
    ID_Dealers: "302106",
    ID_sucursales: "905572",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "23 CORDOBA",
    City: "MONTERIA",
  },
  {
    CONCESIONARIO: "FERSAUTOS",
    DEPARTAMENTO: "N. DE SANTANDER",
    CIUDAD: "CÚCUTA",
    VITRINA_EXPOSICION: "Cúcuta",
    COD_VITRINA_EXPOSICION: "a17QC00000bLDDKYA4",
    NIT: "8040027241",
    ID_Dealers: "302105",
    ID_sucursales: "905568",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "54 N. DE SANTANDER",
    City: "CUCUTA",
  },
  {
    CONCESIONARIO: "FERSAUTOS",
    DEPARTAMENTO: "ANTIOQUIA",
    CIUDAD: "MEDELLÍN",
    VITRINA_EXPOSICION: "Guayabal",
    COD_VITRINA_EXPOSICION: "a17QC00000bLDDJYA4",
    NIT: "8040027241",
    ID_Dealers: "302105",
    ID_sucursales: "905567",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "05 ANTIOQUIA",
    City: "MEDELLIN",
  },
  {
    CONCESIONARIO: "LOS COCHES",
    DEPARTAMENTO: "BOGOTA",
    CIUDAD: "BOGOTÁ",
    VITRINA_EXPOSICION: "Calle 26",
    COD_VITRINA_EXPOSICION: "a17QC00000avsn2YAA",
    NIT: "8600526342",
    ID_Dealers: "302082",
    ID_sucursales: "905619",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "11 BOGOTA",
    City: "BOGOTA, D.C.",
  },
  {
    CONCESIONARIO: "MADIAUTOS",
    DEPARTAMENTO: "BOGOTA",
    CIUDAD: "BOGOTÁ",
    VITRINA_EXPOSICION: "Morato",
    COD_VITRINA_EXPOSICION: "a17QC00000bL1JGYA0",
    NIT: "8000847285",
    ID_Dealers: "302089",
    ID_sucursales: "905649",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "11 BOGOTA",
    City: "BOGOTA, D.C.",
  },
  {
    CONCESIONARIO: "MOTOR HYUNDAI",
    DEPARTAMENTO: "NARIÑO",
    CIUDAD: "PASTO",
    VITRINA_EXPOSICION: "Motor Hyundai",
    COD_VITRINA_EXPOSICION: "a17QC00000bLFYXYA4",
    NIT: "9011372606",
    ID_Dealers: "302116",
    ID_sucursales: "905589",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "52 NARIÑO",
    City: "PASTO",
  },
  {
    CONCESIONARIO: "REINDUSTRIAS",
    DEPARTAMENTO: "TOLIMA",
    CIUDAD: "IBAGUE",
    VITRINA_EXPOSICION: "Ibague",
    COD_VITRINA_EXPOSICION: "a17QC00000aw6kkYAA",
    NIT: "8130071475",
    ID_Dealers: "302100",
    ID_sucursales: "905607",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "73 TOLIMA",
    City: "IBAGUE",
  },
  {
    CONCESIONARIO: "REINDUSTRIAS",
    DEPARTAMENTO: "HUILA",
    CIUDAD: "NEIVA",
    VITRINA_EXPOSICION: "Neiva",
    COD_VITRINA_EXPOSICION: "a17QC00000aw6kiYAA",
    NIT: "8130071475",
    ID_Dealers: "302100",
    ID_sucursales: "905605",
    TIPO_DE_VEHICULOS: "PARTICULARES",
    Department_Code_And_Name: "41 HUILA",
    City: "NEIVA",
  },
];

const ContenidoComponent: React.FC<propsI> = ({ handleOpenModal }) => {
  const [nombre, setNombre]: any = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [celular, setCelular] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");
  const [tipoConsulta, setTipoConsulta] = useState("");
  const [tipoSolicitud, setTipoSolicitud] = useState("");
  const [concesionario, setConcesionario] = useState("");
  const [concesionarios, setConcesionarios] = useState([]);
  const [sede, setSede] = useState("");
  const [modelo, setModelo] = useState("");
  const [modelos, setModelos] = useState([
    {
      nombremodelo: "IONIQ 5 EV",
      nombrefamilia: "IONIQ 5",
      internal: "IONIQ 5",
      idmodelo: "a1YQC000000FK4s2AG",
      idfamilia: "a1FQC000007vHGE2A2",
    },
    {
      nombremodelo: "TUCSON 2.0L",
      nombrefamilia: "TUCSON GASOLINA",
      internal: "TUCSON XL Gasolina",
      idmodelo: "a1YQC000000FL4A2AW",
      idfamilia: "a1FQC000007vHWM2A2",
    },
    {
      nombremodelo: "TUCSON 1.6T HEV",
      nombrefamilia: "TUCSON HIBRIDA",
      internal: "TUCSON Híbrida",
      idmodelo: "a1YQC000001AXN72AO",
      idfamilia: "a1FQC00000U0pFl2AJ",
    },
    {
      nombremodelo: "GRAND I10 1.2L",
      nombrefamilia: "GRAND I10",
      internal: "GRAND METRO SEDÁN",
      idmodelo: "a1YQC000000FKT42AO",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10 HB 1.2L",
      nombrefamilia: "GRAND I10",
      internal: "GRAND METRO HATCHBACK",
      idmodelo: "a1YQC0000010Fhd2AE",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "CRETA 1.5L",
      nombrefamilia: "CRETA",
      internal: "CRETA",
      idmodelo: "a1YQC000000FLTx2AO",
      idfamilia: "a1FQC000007vHuX2AU",
    },
    {
      nombremodelo: "HB20 1.6L",
      nombrefamilia: "HB20",
      internal: "HB20 Hatchback",
      idmodelo: "a1YQC000000FKrG2AW",
      idfamilia: "a1FQC000007vI7R2AU",
    },
    {
      nombremodelo: "HB20S 1.6L",
      nombrefamilia: "HB20S",
      internal: "HB20S Sedán",
      idmodelo: "a1YQC000000FLIf2AO",
      idfamilia: "a1FQC000007vI932AE",
    },
    {
      nombremodelo: "KONA 2.0L",
      nombrefamilia: "KONA",
      internal: "KONA Gasolina",
      idmodelo: "a1YQC000000FLtl2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida",
      idmodelo: "a1YQC000000FLvN2AW",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA EV",
      nombrefamilia: "KONA",
      internal: "KONA Eléctrica",
      idmodelo: "a1YQC000000FM6f2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida N Line",
      idmodelo: "a1YQC000000eQyH2AU",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "PALISADE 3.5L",
      nombrefamilia: "PALISADE",
      internal: "PALISADE",
      idmodelo: "a1YQC000000FM9t2AG",
      idfamilia: "a1FQC000007vIH72AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA panel",
      idmodelo: "a1YQC000000FK9i2AG",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 3.5L",
      nombrefamilia: "STARIA",
      internal: "STARIA lujo",
      idmodelo: "a1YQC000000FMD72AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA pasajeros",
      idmodelo: "a1YQC000000FMEj2AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "VENUE 1.6L",
      nombrefamilia: "VENUE",
      internal: "VENUE",
      idmodelo: "a1YQC000000FMhl2AG",
      idfamilia: "a1FQC000007vILx2AM",
    },
    {
      nombremodelo: "SANTA FE 1.6T HEV",
      nombrefamilia: "SANTA FE Híbrida",
      internal: "SANTA FE Híbrida",
      idmodelo: "a1YQC0000011VPN2A2",
      idfamilia: "a1FQC00000PcdoL2AR",
    },
  ]);
  const [placa, setPlaca] = useState("");
  const [vin, setVin] = useState("");
  const [kilometraje, setKilometraje]: any = useState("");
  const [mensaje, setMensaje] = useState("");
  const [politica1, setPolitica1] = useState(false);
  const [politica2, setPolitica2] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [error, setError]: any = useState({});

  const isValid = () => {
    return (
      validarTexto(nombre, 2, 50) &&
      validarTexto(apellido, 2, 50) &&
      validarCorreo(correo) &&
      validarCelular(celular) &&
      validarTexto(ciudad, 2, 50) &&
      validarTexto(tipoDocumento, 2, 30) &&
      validarNumero(numeroDocumento, 5, 20) &&
      validarTexto(tipoConsulta, 2, 50) &&
      validarTexto(tipoSolicitud, 2, 50) &&
      validarTexto(concesionario, 2, 50) &&
      validarTexto(modelo, 1, 50) &&
      validarTexto(placa, 5, 10) &&
      validarTexto(vin, 17, 17) &&
      validarKilometraje(kilometraje) &&
      politica1 &&
      politica2
    );
  };

  const validarCampos = () => {
    const errores: any = {};

    if (!validarTexto(nombre, 2, 50))
      errores.nombre = "Nombre inválido (2-50 caracteres)";
    if (!validarTexto(apellido, 2, 50))
      errores.apellido = "Apellido inválido (2-50 caracteres)";
    if (!validarCorreo(correo)) errores.correo = "Correo inválido";
    if (!validarCelular(celular))
      errores.celular = "Número de celular inválido";
    if (!validarTexto(ciudad, 2, 50))
      errores.ciudad = "Ciudad inválida (2-50 caracteres)";
    if (!validarTexto(tipoDocumento, 2, 30))
      errores.tipoDocumento = "Tipo de documento inválido";
    if (!validarNumero(numeroDocumento, 5, 20))
      errores.numeroDocumento = "Número de documento inválido";
    if (!validarTexto(tipoConsulta, 2, 50))
      errores.tipoConsulta = "Tipo de consulta inválido";
    if (!validarTexto(tipoSolicitud, 2, 50))
      errores.tipoSolicitud = "Tipo de solicitud inválida";
    if (!validarTexto(concesionario, 2, 50))
      errores.concesionario = "Concesionario inválido";
    if (!validarTexto(modelo, 1, 50)) errores.modelo = "Modelo inválido";
    if (!validarTexto(placa, 5, 10))
      errores.placa = "Placa inválida (5-10 caracteres)";
    if (!validarTexto(vin, 17, 17))
      errores.vin = "VIN inválido (Debe tener 17 caracteres)";
    if (!validarKilometraje(kilometraje))
      errores.kilometraje = "Kilometraje inválido (1-1,000,000 km)";
    if (!politica1) errores.politica1 = "Debes aceptar la política de datos";
    if (!politica2)
      errores.politica2 = "Debes autorizar la transferencia de datos";

    setError(errores);
    return Object.keys(errores).length === 0;
  };

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    const fieldValue = value; // Manejar checkboxes

    setError((prevErrores: any) => {
      const nuevosErrores = { ...prevErrores };

      if (name === "nombre")
        nuevosErrores.nombre = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Nombre inválido (2-50 caracteres)";
      if (name === "apellido")
        nuevosErrores.apellido = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Apellido inválido (2-50 caracteres)";
      if (name === "correo")
        nuevosErrores.correo = validarCorreo(fieldValue as string)
          ? ""
          : "Correo inválido";
      if (name === "celular")
        nuevosErrores.celular = validarCelular(fieldValue as string)
          ? ""
          : "Número de celular inválido";
      if (name === "ciudad")
        nuevosErrores.ciudad = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Ciudad inválida (2-50 caracteres)";
      if (name === "tipoDocumento")
        nuevosErrores.tipoDocumento = validarTexto(fieldValue as string, 2, 30)
          ? ""
          : "Tipo de documento inválido";
      if (name === "numeroDocumento")
        nuevosErrores.numeroDocumento = validarNumero(fieldValue, 5, 20)
          ? ""
          : "Número de documento inválido";
      if (name === "tipoConsulta")
        nuevosErrores.tipoConsulta = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Tipo de consulta inválido";
      if (name === "tipoSolicitud")
        nuevosErrores.tipoSolicitud = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Tipo de solicitud inválida";
      if (name === "concesionario")
        nuevosErrores.concesionario = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Concesionario inválido";
      if (name === "modelo")
        nuevosErrores.modelo = validarTexto(fieldValue as string, 1, 50)
          ? ""
          : "Modelo inválido";
      if (name === "placa")
        nuevosErrores.placa = validarTexto(fieldValue as string, 5, 10)
          ? ""
          : "Placa inválida (5-10 caracteres)";
      if (name === "vin")
        nuevosErrores.vin = validarTexto(fieldValue as string, 17, 17)
          ? ""
          : "VIN inválido (Debe tener 17 caracteres)";
      if (name === "kilometraje")
        nuevosErrores.kilometraje = validarKilometraje(Number(fieldValue))
          ? ""
          : "Kilometraje inválido (1-1,000,000 km)";
      //if (name === "politica1" || name === "politica2") nuevosErrores[name] = checked ? "" : "Este campo es obligatorio";

      return nuevosErrores;
    });
  };
  // Funciones auxiliares de validación

  const validarTexto = (valor: string, min: number, max: number) => {
    return (
      typeof valor === "string" &&
      valor.trim().length >= min &&
      valor.trim().length <= max
    );
  };

  const validarNumero = (valor: string | number, min: number, max: number) => {
    const num = Number(valor);
    return (
      !isNaN(num) &&
      num.toString().length >= min &&
      num.toString().length <= max
    );
  };

  const validarCorreo = (correo: string) => {
    const regexCorreo = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    return regexCorreo.test(correo);
  };

  const validarCelular = (celular: string) => {
    const regexCelular = /^\+?\d{7,15}$/;
    return regexCelular.test(celular);
  };

  const validarKilometraje = (kilometraje: number) => {
    return !isNaN(kilometraje) && kilometraje > 0 && kilometraje <= 1000000;
  };

  const handleSubmit = async () => {
    setIsLogin(true);
    if (validarCampos() && !isLogin) {
      try {
        const response = await fetch(
          `https://gateway.hyundaicolombia.co/crearCaso`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              nombre: nombre,
              apellido: apellido,
              correo: correo,
              celular: celular,
              cedula: tipoDocumento,
              vehiculo_interes: modelo,
              kilometraje: kilometraje,
              placa: placa,
              vin: vin,
              mensaje: mensaje,
              legalComunicaciones: "1",
              subject: tipoSolicitud,
              tipo_consulta: tipoConsulta,
              tipo_documento: numeroDocumento,
              concesionario: concesionario,
              sede: concesionariosData?.filter(
                (e: any) => e.NIT === concesionario
              )[0].COD_VITRINA_EXPOSICION,
              provincia: `${
                concesionariosData?.filter((e: any) => e.CIUDAD === ciudad)[0]
                  .DEPARTAMENTO
              }|${
                concesionariosData?.filter((e: any) => e.CIUDAD === ciudad)[0]
                  .City
              }`,
            }),
          }
        );
        const data = await response.json();
        //console.log("Send Cotizacion: ", data);
        sendFormPQRS({
          data: {
            user_name: nombre,
            user_lastname: apellido,
            user_email: correo,
            user_phone: celular,
            user_cc: tipoDocumento,
            vehicle: modelo,
            vehicle_kilometers: kilometraje,
            vehicle_plate: placa,
            vin: vin,
            message: mensaje,
            comm_legals: "1",
            subject: tipoSolicitud,
            pqr_type: tipoConsulta,
            user_cc_type: numeroDocumento,
            concessionaire: concesionario,
            branch_office: concesionariosData?.filter(
              (e: any) => e.NIT === concesionario
            )[0].COD_VITRINA_EXPOSICION,
            province: `${
              concesionariosData?.filter((e: any) => e.CIUDAD === ciudad)[0]
                .DEPARTAMENTO
            }|${
              concesionariosData?.filter((e: any) => e.CIUDAD === ciudad)[0]
                .City
            }`,
          },
        }).then(function (res: any) {
          setNombre("");
          setApellido("");
          setCorreo("");
          setCelular("");
          setCiudad("");
          setTipoDocumento("");
          setNumeroDocumento("");
          setTipoConsulta("");
          setTipoSolicitud("");
          setConcesionario("");
          setSede("");
          setModelo("");
          setPlaca("");
          setVin("");
          setKilometraje("");
          setMensaje("");
          setPolitica1(false);
          setPolitica2(false);
          handleOpenModal();
          setIsLogin(false);
        });
      } catch (error) {
        console.error("Error fetching concesionarios: ", error);
      }
    }
  };

  const fetchConcesionarios = async (ciudad: string) => {
    try {
      setConcesionarios(
        concesionariosData?.filter((e: any) => e.CIUDAD === ciudad)
      ); // Actualiza el estado con los concesionarios obtenidos
    } catch (error) {
      console.error("Error fetching concesionarios: ", error);
    }
  };

  return (
    <div className="pqr-container-component">
      <div className="left">
        <div className="title">Envíanos un mensaje</div>
        <div className="form row">
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label>Nombre</label>
              <input
                type="text"
                name="nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                onBlur={handleBlur}
              />
              {error.nombre && <span className="error">{error.nombre}</span>}
            </div>
          </div>

          {/* Más campos con validaciones */}
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label>Apellido</label>
              <input
                type="text"
                name="apellido"
                value={apellido}
                onChange={(e) => setApellido(e.target.value)}
                onBlur={handleBlur}
              />
              {error.apellido && (
                <span className="error">{error.apellido}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label>Correo</label>
              <input
                type="email"
                name="correo"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                onBlur={handleBlur}
              />
              {error.correo && <span className="error">{error.correo}</span>}
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="">Celular</label>
              <input
                type="tel"
                name="celular"
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                onBlur={handleBlur}
              />
              {error.celular && <span className="error">{error.celular}</span>}
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="">Ciudad</label>
              <select
                name="ciudad"
                value={ciudad}
                onChange={(e) => {
                  setCiudad(e.target.value),
                    fetchConcesionarios(e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value="">Selecciona</option>
                {Array.from(
                  new Set(concesionariosData.map((item: any) => item.CIUDAD))
                ).map((ciudad: any) => (
                  <option key={ciudad} value={ciudad}>
                    {ciudad}
                  </option>
                ))}
              </select>
              {error.ciudad && <span className="error">{error.ciudad}</span>}
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="">Tipo de documento</label>
              <select
                name="tipoDocumento"
                value={tipoDocumento}
                onChange={(e) => setTipoDocumento(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">-Tipo de documento-</option>
                <option value="nid">Cédula de ciudadanía</option>
                <option value="foreigner_id">Cédula Extranjería</option>
                <option value="passport">Pasaporte</option>
                <option value="CIF">NIF</option>
              </select>
              {error.tipoDocumento && (
                <span className="error">{error.tipoDocumento}</span>
              )}
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="numeroDocumento">Número de documento</label>
              <input
                type="text"
                name="numeroDocumento"
                value={numeroDocumento}
                onChange={(e) => setNumeroDocumento(e.target.value)}
                onBlur={handleBlur}
              />
              {error.numeroDocumento && (
                <span className="error">{error.numeroDocumento}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="tipoConsulta">Tipo de consulta</label>
              <select
                name="tipoConsulta"
                value={tipoConsulta}
                onChange={(e) => setTipoConsulta(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">-Tipo de consulta-</option>
                <option value="Marketing">Marketing</option>
                <option value="Ventas">Ventas</option>
                <option value="Postventa">Postventa</option>
              </select>
              {error.tipoConsulta && (
                <span className="error">{error.tipoConsulta}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="tipoSolicitud">Tipo de solicitud</label>
              <select
                name="tipoSolicitud"
                value={tipoSolicitud}
                onChange={(e) => setTipoSolicitud(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">Seleccionar</option>
                {tipoConsulta === "Marketing" && (
                  <>
                    <option value="Consulta - Solicitud de información Marketing">
                      Consulta - Solicitud de información Marketing
                    </option>
                    <option value="Reclamación Marketing">
                      Reclamación Marketing
                    </option>
                    <option value="Llamada de Cortesía">
                      Llamada de Cortesía
                    </option>
                  </>
                )}

                {tipoConsulta === "Ventas" && (
                  <>
                    <option value="Consulta - Solicitud información de ventas">
                      Consulta - Solicitud información de ventas
                    </option>
                    <option value="Oferta comercial Vehículos">
                      Oferta comercial Vehículos
                    </option>
                    <option value="Reclamación de Ventas">
                      Reclamación de Ventas
                    </option>
                  </>
                )}

                {tipoConsulta === "Postventa" && (
                  <>
                    <option value="Reclamación Postventa">
                      Reclamación Postventa
                    </option>
                    <option value="Consulta - Solicitud de información Postventa">
                      Consulta - Solicitud de información Postventa
                    </option>
                    <option value="Reclamación APP">Reclamación APP</option>
                    <option value="Consulta - Solicitud información APP">
                      Consulta - Solicitud información APP
                    </option>
                    <option value="Reclamación de sistemas">
                      Reclamación de sistemas
                    </option>
                    <option value="Consulta - Solicitud de información de sistemas">
                      Consulta - Solicitud de información de sistemas
                    </option>
                    <option value="Oportunidad Comercial (Lead)">
                      Oportunidad Comercial (Lead)
                    </option>
                    <option value="Llamada de Cortesía">
                      Llamada de Cortesía
                    </option>
                  </>
                )}
              </select>

              {error.tipoSolicitud && (
                <span className="error">{error.tipoSolicitud}</span>
              )}
            </div>
          </div>

          <div className="col-lg-12 col-sm-12 mb-6">
            <div className="subTitle">
              Soy propietario de un Hyundai (Opcional)
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="concesionario">Concesionario</label>
              <select
                name="concesionario"
                value={concesionario}
                onChange={(e) => setConcesionario(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">Selecciona</option>
                {concesionarios?.map((concesionario: any) => (
                  <option key={concesionario.NIT} value={concesionario.NIT}>
                    {concesionario.CONCESIONARIO}
                  </option>
                ))}
              </select>
              {error.concesionario && (
                <span className="error">{error.concesionario}</span>
              )}
            </div>
          </div>

          {/* <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="sede">Sede</label>
              <select
                name="sede"
                value={sede}
                onChange={(e) => setSede(e.target.value)}
              >
                <option value="">Seleccionar</option>
                <option value="sede1">Sede 1</option>
              </select>
              {error.sede && <span className="error">{error.sede}</span>}
            </div>
          </div> */}

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="modelo">Modelo</label>
              <select
                name="modelo"
                value={modelo}
                onChange={(e) => setModelo(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">Selecciona</option>
                {modelos?.map((model: any) => (
                  <option key={model.nombremodelo} value={model.nombremodelo}>
                    {model.nombremodelo}
                  </option>
                ))}
              </select>
              {error.modelo && <span className="error">{error.modelo}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="placa">Placa</label>
              <input
                type="text"
                name="placa"
                value={placa}
                onChange={(e) => setPlaca(e.target.value)}
                onBlur={handleBlur}
              />
              {error.placa && <span className="error">{error.placa}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="vin">VIN</label>
              <input
                type="text"
                name="vin"
                value={vin}
                onChange={(e) => setVin(e.target.value)}
                onBlur={handleBlur}
              />
              {error.vin && <span className="error">{error.vin}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="kilometraje">Kilometraje</label>
              <input
                type="text"
                name="kilometraje"
                value={kilometraje}
                onChange={(e) => setKilometraje(e.target.value)}
                onBlur={handleBlur}
              />
              {error.kilometraje && (
                <span className="error">{error.kilometraje}</span>
              )}
            </div>
          </div>

          <div className="col-lg-12 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="mensaje">Mensaje</label>
              <textarea
                name="mensaje"
                value={mensaje}
                onChange={(e) => setMensaje(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="col-lg-12 col-sm-12 mb-4">
            <div className="campo-check">
              <div>
                <input
                  type="checkbox"
                  name="politica_1"
                  checked={politica1}
                  onChange={(e) => setPolitica1(e.target.checked)}
                />
              </div>
              <label htmlFor="">
                Acepto política de datos, términos y condiciones.
              </label>
            </div>
          </div>
          <div className="col-lg-12 col-sm-12 mb-4">
            <div className="campo-check">
              <div>
                <input
                  type="checkbox"
                  name="politica_2"
                  checked={politica2}
                  onChange={(e) => setPolitica2(e.target.checked)}
                />
              </div>
              <label htmlFor="">
                Autorizo la transferencia y transmisión de mis datos.
              </label>
            </div>
          </div>
        </div>
        <div className="text_legal">
          Estamos comprometidos con tu privacidad, por ello, en Hyundai Colombia
          S.A.S. junto con nuestros aliados oficiales te aseguramos que
          utilizaremos la información que nos proporcionas para comunicarnos
          contigo acerca de nuestros productos, servicios, ofertas,
          invitaciones, encuestas, entre otras finalidades y contenidos
          relevantes para ti. Puedes darte de baja de estas comunicaciones en
          cualquier momento. Para obtener más información consulta nuestra
        </div>
        <div
          className={`send ${isValid() && !isLogin ? "active" : ""}`}
          onClick={handleSubmit}
        >
          Enviar mensaje
          {isValid() && isLogin ? (
            <span
              className="spinner-border spinner-border-sm ms-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : null}
        </div>
      </div>
      <div className="right">
        <div className="title">Queremos escucharte</div>
        {/* <div className="subtitle">Acércate a nuestras oficinas</div>
        <div className="txt">
          Avenida Carrera 45 - 108 - 27 Torre 3 Piso 12 Bogotá D.C., Colombia.
        </div> */}
        <div className="subtitle">Envíanos un correo</div>
        <div className="txt">scliente.hyundai.co@astara.com</div>
        <div className="subtitle">Llámanos</div>
        <div className="txt">Línea de servicio al cliente 01 8000 931 030</div>
        <a
          target="blank"
          href={"https://wa.me/5715190055?text=Hyundai"}
          className="chatea"
        >
          Contáctanos por WhatsApp
        </a>
      </div>
    </div>
  );
};

export default ContenidoComponent;
